<template>
  <div>

    <h2 class="entry-title">Mockup 2</h2>

    <p>Introduction section</p>

    <p> This is some more test</p>

    <h3 v-if="data">
      {{ data.State }}
    </h3>

    <div v-for="(g, glabel) in groups">
      <h4>{{ glabels[glabel] }}</h4>

      <div class="section">
        <div v-for="column in groups[glabel]">
          <card class="my-3 mx-auto" :name="describe(column)">
            <template #header>
              <details v-if="dictLookup(column)">
                <summary> {{ describe(column) }} </summary>
                {{ dictLookup(column)?.description ?? "description" }}
              </details>
            </template>
            {{ decode(column) }}
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "../components/Card.vue";
export default {
  components: { Card },
  inheritAttrs: false,
  props: ["data", "dict", "groups"],
  data() {
    return {
      glabels: {
        "eligibility-vi":
          "Eligibility: “Visual Impairments including Blindness”",
        "el-de": "Eligibility: Deafblindness",
        "cert-tvi": "Certification: Teachers of Students with Visual Impairments",
        "cert-om": "Certification: Orientation & Mobility",
      },
    };
  },
  methods: {
    dictLookup(term) {
      let lookup = this.dict?.[term] ?? null;
      return lookup;
    },
    decode(term) {
      let lookup = this.dict?.[term] ?? null;
      return lookup?.coding?.[this.data[term]] ?? this.data[term];
    },
    describe(term) {
      let lookup = this.dict?.[term] ?? null;
      return lookup?.name ?? term;
    },
  },
};
</script>

<style></style>